/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimePointListEntry } from './timePointListEntry';


export interface HistInfo { 
    erstellzeitpunkt?: Date;
    histEnum?: HistInfo.HistEnumEnum;
    vonTimePoint?: TimePointListEntry;
    bisTimePoint?: TimePointListEntry;
}
export namespace HistInfo {
    export type HistEnumEnum = 'ILLEGALER_ZUSTAND' | 'ERSTERFASSUNG' | 'GRUNDSTUECK_PROVISORISCH' | 'VON_RECHTGUELTIG_BIS_NULL' | 'VON_RECHTGUELTIG_BIS_AKTUELL' | 'VON_RECHTGUELTIG_BIS_VERKNUEPFT' | 'VON_RECHTGUELTIG_BIS_VORGAENGIG' | 'VON_RECHTGUELTIG_BIS_RECHTSGUELTIG' | 'VON_VORGAENGIG_BIS_NULL' | 'VON_VORGAENGIG_BIS_AKTUELL' | 'VON_VORGAENGIG_BIS_VERKNUEPFT' | 'VON_VORGAENGIG_BIS_VORGAENGER' | 'VON_VERKNUEPFT_BIS_NULL' | 'VON_VERKNUEPFT_BIS_AKTUELL' | 'VON_VERKNUEPFT_BIS_VERKNUEPFT' | 'VON_AKTUELL_BIS_NULL' | 'VON_AKTUELL_BIS_AKTUELL';
    export const HistEnumEnum = {
        ILLEGALER_ZUSTAND: 'ILLEGALER_ZUSTAND' as HistEnumEnum,
        ERSTERFASSUNG: 'ERSTERFASSUNG' as HistEnumEnum,
        GRUNDSTUECK_PROVISORISCH: 'GRUNDSTUECK_PROVISORISCH' as HistEnumEnum,
        VON_RECHTGUELTIG_BIS_NULL: 'VON_RECHTGUELTIG_BIS_NULL' as HistEnumEnum,
        VON_RECHTGUELTIG_BIS_AKTUELL: 'VON_RECHTGUELTIG_BIS_AKTUELL' as HistEnumEnum,
        VON_RECHTGUELTIG_BIS_VERKNUEPFT: 'VON_RECHTGUELTIG_BIS_VERKNUEPFT' as HistEnumEnum,
        VON_RECHTGUELTIG_BIS_VORGAENGIG: 'VON_RECHTGUELTIG_BIS_VORGAENGIG' as HistEnumEnum,
        VON_RECHTGUELTIG_BIS_RECHTSGUELTIG: 'VON_RECHTGUELTIG_BIS_RECHTSGUELTIG' as HistEnumEnum,
        VON_VORGAENGIG_BIS_NULL: 'VON_VORGAENGIG_BIS_NULL' as HistEnumEnum,
        VON_VORGAENGIG_BIS_AKTUELL: 'VON_VORGAENGIG_BIS_AKTUELL' as HistEnumEnum,
        VON_VORGAENGIG_BIS_VERKNUEPFT: 'VON_VORGAENGIG_BIS_VERKNUEPFT' as HistEnumEnum,
        VON_VORGAENGIG_BIS_VORGAENGER: 'VON_VORGAENGIG_BIS_VORGAENGER' as HistEnumEnum,
        VON_VERKNUEPFT_BIS_NULL: 'VON_VERKNUEPFT_BIS_NULL' as HistEnumEnum,
        VON_VERKNUEPFT_BIS_AKTUELL: 'VON_VERKNUEPFT_BIS_AKTUELL' as HistEnumEnum,
        VON_VERKNUEPFT_BIS_VERKNUEPFT: 'VON_VERKNUEPFT_BIS_VERKNUEPFT' as HistEnumEnum,
        VON_AKTUELL_BIS_NULL: 'VON_AKTUELL_BIS_NULL' as HistEnumEnum,
        VON_AKTUELL_BIS_AKTUELL: 'VON_AKTUELL_BIS_AKTUELL' as HistEnumEnum
    };
}


